import { render } from "./ProjectForms.vue?vue&type=template&id=4aae9758&ts=true"
import script from "./ProjectForms.vue?vue&type=script&lang=ts"
export * from "./ProjectForms.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__